import { Card } from "antd";
import { t } from "i18next";
import { useEffect } from "react";
import moment from "moment";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import { DataGridProvider } from "../../core/components/data-grid/DataGridContext";
import AppConfig from "../../core/service/AppConfig";
import EnabizOperationFilter from "./EnabizOperationFilter";
import EnabizOperationDataGrid from "./EnabizOperationDataGrid";

export default function EnabizOperationApp() {
    useEffect(() => {
        document.title = `${t('Enabiz Operation Tracking')} - ${AppConfig.getHisTitle()}`
    }, []);

    return (
        <SimpleLayout fullWidth={true}>
            <Card title={t('Enabiz Operation Tracking')}>
                <DataGridProvider
                    defaultFilter={{
                        startDate: moment().subtract(7, 'days'),
                        endDate: moment(),
                        stateGroupIdList: [2],
                    }}
                >
                    <EnabizOperationFilter />
                    <EnabizOperationDataGrid />
                </DataGridProvider>
            </Card>
        </SimpleLayout>
    )
}
